// src/hide-removed-fields.js
import React from "react";

import logDebug, {debounce, clearValidationErrorsInField}  from './extraFunction.js'

const initMutationObserver = (callback) => {
  const parentElement = document.querySelector(".wp-site-blocks");
  if (!parentElement) {
    logDebug('.wp-site-blocks не найден в DOM');
    return null;
  }
  const observer = new MutationObserver(callback);
  observer.observe(parentElement, { childList: true, subtree: true });
  return observer;
};

const HideBillingFields = React.memo(({
  areas = ["billing", "shipping"],
  hideFields = {},
  children,
  differentFields = {},
}) => {
  // logDebug('HideBillingFields', areas, hideFields, differentFields);
  
  React.useEffect(() => {
    const recoveryFields = () => {
      const fields = differentFields;
      Object.keys(fields).forEach((area) => {
        fields[area].forEach((fieldKey) => {
          const selector = `#${area}-${fieldKey}`;
          const field = document.querySelector(selector);
          if (!field) return;
          if (field.nodeName.toLowerCase() === "span") {
            if(field.classList.contains("hidden-field")) {
              field.classList.remove("hidden-field");
            }
          } else {
            const parentDiv = document.querySelector(`.wc-block-components-address-form__${selector.replace("#" + `${area}-`, "")}`) ? field.closest(`.wc-block-components-address-form__${selector.replace("#" + `${area}-`, "")}`) : field.closest('div');
            if (parentDiv && !(parentDiv.classList.contains('wc-block-components-address-form') || parentDiv.getAttribute('id') === area)) {
              if(parentDiv.classList.contains("hidden-field")) {
                parentDiv.classList.remove("hidden-field");
              }
            } else {
              if(field.classList.contains("hidden-field")) {
                field.classList.remove("hidden-field");
              }
            }
          }
        });
        logDebug(`differentFields for ${area}:`, fields[area]);
      });
    }
    const debouncedShow = debounce(recoveryFields, 300); 
    debouncedShow();
    const observer = initMutationObserver(debouncedShow);
    if (!observer) return;
    return () => {
      observer.disconnect();
    }
  }, [differentFields]);
  React.useEffect(() => {
    
    const hideSpecifiedFields = () => {
      
      areas.forEach(area => {
        // Формируем селекторы из hideFields для данной области
        let fieldsToHide = ([...(hideFields[area] || [])]).map(f => `#${area}-${f}`);
        let address_2_toggle = null;
        // Дополнительно, можно добавить стандартные селекторы, если их не переопределили
        if ( fieldsToHide.includes(`#${area}-address_1`) ) {
          const childDiv = document.querySelector(`#${area}-address_1`);
          if (childDiv) {
            address_2_toggle = childDiv.closest('div[id="' + area + '"]')
              ? `div#${area} [class*="address_2-toggle"]`
              : null;
          }

          logDebug("address_2_toggle", address_2_toggle);
          if (
            fieldsToHide.includes(`#${area}-address_1`) &&
            childDiv
          ) {
            fieldsToHide = [
              ...fieldsToHide,
              address_2_toggle,
              // `#${area}-address_2`,
            ].filter(v => v !== null);
          }
        }
        logDebug(`fieldsToHide for ${area}:`, fieldsToHide);
       

        let removeErrorValidation = [];
        fieldsToHide.forEach((selector) => {
          let $field_remove = clearValidationErrorsInField(selector, area) || selector.replace('#', "").replaceAll('-', "_");
          const field = document.querySelector(selector.replace('saphali/', 'saphali\\/'));
          if($field_remove) {
            removeErrorValidation.push( $field_remove );
          }
        });
        if (Array.isArray(removeErrorValidation) && removeErrorValidation.length !== 0)
          wp.data.dispatch('wc/store/validation').clearValidationErrors(removeErrorValidation);
        logDebug('removeErrorValidation:', removeErrorValidation);
      });
    };

    // Дебаунс вызова hideSpecifiedFields (например, 500 мс)
    const debouncedHide = debounce(hideSpecifiedFields, 300);
    debouncedHide();
    const observer = initMutationObserver(debouncedHide);
    if (!observer) return;
    return () => {
      observer.disconnect();
    }
  }, [areas, hideFields]);

  // Если children не требуются, можно вернуть null или {children}
  return <>{children}</>;
});

export default HideBillingFields;
